<template>
    <v-container fluid class="px-0">
		<v-data-table
			:headers="tableHeaders"
			:items="filteredItems"
			:loading="tableLoading"
			:loading-text="$t('wkt.admin.common.table.loading')"
			:no-data-text="$t('wkt.admin.common.table.no_data')"
			:no-results-text="$t('wkt.admin.common.table.no_results')"
			:height="tableHeight"
			dense 
			fixed-header
			disable-pagination
			hide-default-footer
			class='elevation-0'
		>
			<template v-slot:top>
				<v-toolbar flat color='white' class='mb-7 px-0'>
					<v-row cols='12' class='d-flex justify-space-between'>
						<v-col cols='12' md='2' class='px-0'>
							<v-text-field
								v-model="search"
								:label="$t('wkt.admin.projects.project.filter_employees')"
								hide-details
								:clearable="true"
								@click:clear="searchTimeOut()"
								@keyup="searchTimeOut()"
							/>
						</v-col>
						<v-col cols='12' md='2' class='px-0 d-flex justify-end'>
							<template>
								<v-btn :disabled="filteredItems.length === 0" text color='#3f51b5' @click='removeAllEmployees()'>
									<v-icon dense color='indigo' class="mr-1">delete</v-icon>
										{{ $t('wkt.admin.projects.project.remove_employees') }}
								</v-btn>
								<v-btn text color='#3f51b5' class="ml-2" @click='addEmployees()'>
									<v-icon dense color='indigo' class="mr-1">people</v-icon>
									{{ $t('wkt.admin.projects.project.add_employees') }}
								</v-btn>
							</template>
						</v-col>
					</v-row>
				</v-toolbar>
			</template>
			<template v-slot:[`item.firstname`]="{ item }">
				<div class="d-flex align-center" style="cursor: pointer;" @click="editItem(item)">
					<v-img :src="getProfileAssetUrl(item.profilePicture)" max-width="25" max-height="25" class="mr-2" />
					<span :style="'font-size: 0.85em; color: ' + (item.isEnabled ? '#212121' : '#FF0000') + ';'">
						{{ getEmployeeFullname(item) }}
					</span>
				</div>
			</template>
			<template v-slot:[`item.dedication`]="{ item }">
				<span>{{ item.dedication ? item.dedication : 0 }}</span>
			</template>
			<template v-slot:[`item.actions`]="{ item }">
				<v-btn v-if="projectType === 0" text color="#3f51b5" class="mr-4" @click.stop="editEmployee(item)">
					{{ $t('wkt.admin.projects.project.table.edit_employee') }}
				</v-btn>
				<v-btn text color="#3f51b5" @click.stop="removeEmployee(item)">
					{{ $t('wkt.admin.projects.project.table.remove_employee') }}
				</v-btn>
			</template>
			<template v-slot:no-data>
				<EmptyState 
					class="pt-10"
					:title="emptyStateTitle" 
					:description="emptyStateDescription" />
			</template>
		</v-data-table>
    </v-container>
</template>

<script>
import BaseModule from './BaseModule.js';
import EmptyState from './EmptyState.vue';

export default {
	name: 'EmployeesManager',
	mixins: [BaseModule],
	props: ['projectType', 'tableLoading', 'tableHeaders', 'tableItems', 'tableHeight', 'emptyStateTitle', 'emptyStateDescription'],
	components: {
		EmptyState
	},
	watch: {
		tableHeaders: {
			immediate: true,
			deep: true,
			// eslint-disable-next-line no-unused-vars
			handler(newValue, oldValue) {
				this.search = '';
			}
		},
		tableItems: {
			immediate: true,
			deep: true,
			// eslint-disable-next-line no-unused-vars
			handler(newValue, oldValue) {
				this.filterEmployees(this.search);
			}
		}
	},
	data () {
		return {
			search: '',
			filteredItems: []
		}
	},
	mounted() {
	},
	methods: {
		searchTimeOut() {
			if (this.timer) {
				clearTimeout(this.timer);
				this.timer = null;
			}
			this.timer = setTimeout(() => {
				this.filterEmployees(this.search);
			}, 800);
		},
		filterEmployees(search) {
			if (search && search.trim().length > 0) {
				const normalizedSearch = search.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');

				const items = this.tableItems.filter(x => 
					(x.idNumber && x.idNumber.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').indexOf(normalizedSearch) > -1)
					|| (x.firstname && x.firstname.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').indexOf(normalizedSearch) > -1)
					|| (x.lastname && x.lastname.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').indexOf(normalizedSearch) > -1)
					|| (x.workplaceName && x.workplaceName.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').indexOf(normalizedSearch) > -1)
					|| (x.departmentName && x.departmentName.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').indexOf(normalizedSearch) > -1)
				);
				this.filteredItems = [...items];
			} else {
				this.filteredItems = [...this.tableItems];
			}
		},
		getIds(filtered) {
			if (filtered) {
				return this.filteredItems.map(x => x.id);
			} else {
				return this.tableItems.map(x => x.id);
			}
		},
		getEmployeeIds(filtered) {
			if (filtered) {
				return this.filteredItems.map(x => x.employeeId);
			} else {
				return this.tableItems.map(x => x.employeeId);
			}
		},
		removeAllEmployees() {
			this.$emit('remove-all-employees', this.filteredItems.length);
		},
		addEmployees() {
			this.$emit('add-employees');
		},
		editEmployee(item) {
			this.$emit('edit-employee', item.id);
		},
		removeEmployee(item) {
			this.$emit('remove-employee', item.id);
		}
	},
}
</script>